import { BottomSheet } from "react-spring-bottom-sheet";
import styled from "@emotion/styled";
import Popup from "reactjs-popup";
import { CampoDeTexto } from "../../../components/CampoInput";
import {
  Accordion,
  AccordionDetails,
  MenuItem,
  Typography,
} from "@mui/material";
import { X } from "phosphor-react";

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow-y: visible;
  background-color: ${(props) => props.theme.cores.surfaceBackground1};
  margin: 0px 40px 20px 40px;
  padding-bottom: 16px;

  @media (max-width: 768px) {
    margin: 0px 20px 80px 20px;
  }

  .container-tabela {
    height: 440px !important;
  }

  .MuiTextField-root {
    padding-top: 0px !important;
  }

  .MuiInput-input {
    height: unset !important;
  }
`;

export const ContainerFundoBranco = styled.div`
  margin-top: 10px;
  width: 100%;
  background-color: ${(props) => props.theme.cores.surface2};
  display: flex;
  flex-direction: column;
  padding: 38px 20px;

  gap: 16px;
  padding-top: 26px;
  padding-bottom: 16px;
  flex-grow: 1;
  border-radius: 16px 16px 0px 0px;

  h3 {
    font-size: 33px;
    font-weight: 400;
    margin-bottom: 15px;
  }

  p {
    margin-bottom: 15px;
    margin-top: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    h3 {
      font-size: 23px;
    }
    p {
      padding: 0px 10px;
    }
  }
`;

export const StyledBottomSheet = styled(BottomSheet)`
  h2 {
    font-size: 17px;
  }

  [data-rsbs-overlay] {
    background: ${(props) => props.theme.cores.surface2};
    z-index: 101;
    height: unset;
  }

  [data-rsbs-content] {
    padding: 20px 40px 40px 40px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow-y: visible;
  }

  [data-rsbs-scroll] {
    overflow-y: visible;
  }
`;

export const Linha = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 100%;
  border-bottom: 2px solid rgba(0, 0, 0, 0.25);
  padding: 24px 0px;
`;

export const CampoDeTextoTabela = styled(CampoDeTexto)`
  MuiInput-input {
    margin-top: 0px;
    height: unset;
  }
`;

export const Separador = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.24)"};
  margin: 20px 0px;
`;

export const StyledPopup = styled(Popup)`
  &-content {
    max-width: 620px;
    width: 80%;
    min-height: 300px;
    padding: 32px 16px;
    border-radius: 16px;
    background-color: ${({ theme }) =>
      theme.adaptativo("neutral100", "surface2")};
    border: none;
    display: flex;
    flex-direction: column;
  }

  &-overlay {
    background: rgba(0, 0, 0, 0.5);
  }

  &-arrow {
    display: none;
  }
`;

export const Coluna = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ItemContratoNormal = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ContainerItem = styled.div`
  display: flex;
  align-items: center;
  width: 60vw;
  background-color: ${({ theme, $index }) =>
    $index % 2 ? theme.adaptativo("surface3", "neutral10") : "transparent"};
  padding: "24px";
`;

export const ContainerItemCheck = styled.div`
  display: "flex";
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  background-color: ${({ theme, $index }) =>
    $index % 2 ? theme.adaptativo("surface3", "neutral10") : "transparent"};
  padding: 24px;
`;

export const CabecalhoTituloPlano = styled.div`
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.cores.linhaBorda};

  @media (max-width: 400px) {
    flex-direction: column-reverse;
    justify-content: unset;
    gap: 28px;
    margin-bottom: 36px;
  }
`;

export const StyledAccordion = styled(Accordion)`
  box-shadow: none;
  margin: 0;
  margin-bottom: 0;
  background-color: ${(props) => props.theme.adaptativo("brand10", "brand70")};
  padding: 0px 0px;

  svg {
    color: ${(props) => props.theme.textoContrato};
  }

  &.MuiAccordion-root {
    margin: 0;
  }

  thead {
    display: none;
  }

  tr:nth-child(odd) {
    background-color: ${(props) =>
      props.theme.adaptativo("neutral100", "surface2")} !important;
  }

  tr {
    height: 90px;
  }

  .container-tabela {
    height: unset !important;
  }
`;

export const TypographyTitulo = styled(Typography)`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0.5px;
  @media (max-width: 768px) {
    width: 100%;
    font-family: "Comfortaa";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
  }
`;

export const FundoTabela = styled.div`
  background-color: ${(props) => props.theme.adaptativo("brand10", "brand70")};
`;

export const LinhaItem = styled(AccordionDetails)`
  display: flex;
  align-items: center;
  height: 69px;
  padding-right: 16px;
  justify-content: space-between;
`;

export const TextoLinha = styled.p`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: start;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.cores.textoContrato};

  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

export const TextoReativarRecorrencia = styled.p`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;

  color: orange;
`;

export const TextoAdicionar = styled.p`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  text-decoration-line: underline;
  cursor: pointer;
  transition: 0.3s;
  color: ${({ theme }) => theme.cores.actionActive};

  &:hover {
    opacity: 0.7;
  }
`;

export const TextoCancelarRecorrencia = styled.p`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.cores.semanticDanger2};
`;

export const ContainerRemover = styled.div`
  display: flex;
  gap: 13px;
  align-items: center;
`;

export const TextoRemover = styled.p`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  text-decoration-line: underline;
  cursor: pointer;
  transition: 0.3s;
  color: ${({ theme }) => theme.cores.semanticDanger2};

  &:hover {
    opacity: 0.7;
  }
`;

export const CampoDeSessoes = styled.div`
  display: flex;
  flex-direction: row;
  width: 270px;
  margin-bottom: 36px;

  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const CamposInputs = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 700px;
  gap: 32px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ContainerSwitch = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 20px;
  width: 160px;
  height: 28px;
  background-color: ${({ theme }) => theme.cores.bgCard};
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  margin-bottom: 16px;
`;

export const ContainerSwitchUnico = styled(ContainerSwitch)`
  width: 80px;
`;

export const SwitchEstilizado = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  width: 50%;
  height: 100%;
`;

export const SwitchEstilizadoUnico = styled(SwitchEstilizado)`
  width: 100%;
`;

export const TextoVermelho = styled.p`
  color: ${({ theme }) => theme.cores.semanticDanger2};
  font-size: 18px;
  height: 24px;
  justify-content: center;
  align-items: center;
  margin-left: 16px;

  @media (max-width: 400px) {
    text-align: left;
    margin-top: 0px;
  }
  @media (min-width: 400px) and (max-width: 568px) {
    text-align: center;
    margin-top: -64px;
  }

  @media (min-width: 568px) and (max-width: 768px) {
    margin-top: 0px;
    text-align: left;
  }
`;

export const ContainerCustoDesconto = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  width: 100%;
  margin-bottom: 24px;

  @media (max-width: 1020px) {
    flex-direction: column;
    width: 100%;
    gap: 0px;
  }
`;

export const ContainerCampos = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  @media (max-width: 1020px) {
    width: 100%;
  }
`;

export const ContainerCalculoDetalhado = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 16px;
  align-items: flex-end;

  @media (max-width: 1020px) {
    align-items: center;
    width: 100%;
    gap: 0px;
  }
`;

export const ContainerCalculoDetalhadoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.cores.linhaBorda};
  padding: 16px;
  max-width: 400px;
  @media (max-width: 1020px) {
    max-width: 100%;
  }
`;

export const LinhaCalculoDetalhada = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const TituloCalculoDetalhado = styled.p`
  font-size: 17px;
  font-weight: 800;
`;

export const TextoCalculoDetalhado = styled.p`
  font-size: 17px;
  font-weight: 400;
`;

export const LayerDeCustomizacao = styled.div`
  max-width: 400px;
  width: 100%;

  .Mui-expanded {
    /* margin: 0; */
    box-shadow: none;
    background-color: transparent;
    padding: 0;
  }

  .MuiAccordion-root {
    margin: 0;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
  }

  .MuiAccordionSummary-root {
    padding: 0;
  }

  .MuiAccordionSummary-expandIconWrapper {
    position: relative;
    top: 3px;
    /* left: 110px; */
  }

  .MuiAccordionDetails-root {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .MuiAccordionSummary-content {
    margin: 0;
  }

  @media (max-width: 1020px) {
    margin-left: 0px;
    max-width: 100%;
  }
`;

export const ContainerBotaoExtraQuantidade = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

export const MenuItemCustomizado = styled(MenuItem)`
  width: 200px;
`;

export const TextoMenuItem = styled.p`
  width: 100%;
  border-bottom: 1px solid
    ${({ theme }) => theme.cores.surfaceActionActivePrimary};
  padding-bottom: 3px;
`;

export const ConteudoPopUp = styled.div`
  /* padding: 24px; */
  min-width: 400px;
  padding-bottom: 10px;
  @media (max-width: 1100px) {
    min-width: 100%;
  }
`;

export const HeaderPopup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
`;
export const TextoTitulo = styled.h1`
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  color: ${({ theme }) => theme.cores.textoSimples};
`;

export const XIcon = styled(X)`
  height: 24px;
  width: 24px;

  color: ${({ theme }) => theme.cores.semanticDanger2};
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    filter: brightness(0.7);
  }
`;

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const ContainerBotoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 40px;
`;
